/* exported convert2BootstrapRadio, convert2BootstrapCheckbox, convert2BootstrapCheckboxOrRadiobutton_geladen */
function convert2BootstrapRadio(elem) {
	'use strict';
	convert2BootstrapCheckboxOrRadiobutton(elem, 'radio');
}
function convert2BootstrapCheckbox(elem) {
	'use strict';
	convert2BootstrapCheckboxOrRadiobutton(elem, 'checkbox');
}

function convert2BootstrapCheckboxOrRadiobutton_geladen() {
	'use strict';
	return true;
}
/**
 * @description Konvertiert ein oder meherere Elemente von normalen Radiobuttons bzw. Checkboxes zu Bootstrap Cutsom Controls.
 * @param {string} elem Selector-String für ein form-, label- oder input-Element. Bei allen anderen wird nichts gemacht.
 * @param {string} type (optional) Typ des Controls. Wird nur verwendet wenn elem ein label-Element ist. <br /> Wenn nicht übergeben oder null, wird es automatisch ermittelt
 * @param {string} input (optional) Input-Element, dass zum Label gehört. Wird nur verwendet wenn elem ein label-Element ist. <br /> Wenn nicht übergeben oder null, wird es aufgrund des for-Attributs des Labels ermittelt.
 * @returns {void}
 */
function convert2BootstrapCheckboxOrRadiobutton(elem, type, input) {
	'use strict';
	function _getLabelForElem(elem, container) {
		let label = $(`label[for="${$(elem).attr('id')}"]`, container);
		if (label.length !== 1) {
			label = $(elem).parent('label');
		}
		if (label.length !== 1) {
			label = $(elem).next('label');
		}
		return label;
	}

	if ($(elem).is('form')) {
		// Jeden Radiobutton und jede Checkbox umwandeln, für die ein label gefunden werden kann:
		$('[type=radio]', elem).each(function () {
			let label = _getLabelForElem(this, elem);
			if (label.length === 1) {
				convert2BootstrapCheckboxOrRadiobutton(label, 'radio', this);
			}
		});
		$('[type=checkbox]', elem).each(function () {
			let label = _getLabelForElem(this, elem);
			if (label.length === 1) {
				convert2BootstrapCheckboxOrRadiobutton(label, 'checkbox', this);
			}
		});
	} else if ($(elem).is('input')) {
		// Das Input-Element unwandeln, falls es das passende Label innerhalb derselben form gibt:
		let label = _getLabelForElem(elem, $(elem).closest('form'));
		if (label.length === 1) {
			convert2BootstrapCheckboxOrRadiobutton(label, null, elem);
		}
	} else if ($(elem).is('label')) {
		// wenn ein explizietes Input-Feld angeben ist, dann dieses nehmen, sonst, dass was im for-Attribut steht
		const $inputElem = input ? $(input) : $(`#${$(elem).attr('for')}`);
		// Wenn der Input-Type nicht bereits aegeben ist, diesen ermitteln:
		if ($inputElem && (typeof type === 'undefined' || type === null)) {
			if ($inputElem.is('[type=radio]')) {
				type = 'radio';
			} else if ($inputElem.is('[type=checkbox]')) {
				type = 'checkbox';
			} else {
				return; // abbrechen, wenn es weder checkbox noch radio ist!
			}
		}
		// Wenn das Input-Feld nicht direkt vor dem Label liegt, dann das Label hinter den Input verschieben
		if ($inputElem.length === 1 && !$inputElem.next().is(elem)) {
			if ($.contains(elem, $inputElem)) {
				$($inputElem).insertBefore(elem);
			} else {
				$(elem).insertAfter($inputElem);
			}
		}
		// Nötige Bootstrap-Klassen dem Label und dem Input hinzufügen:
		$(elem).add($inputElem).wrapAll(`<div class="form-check custom-${type}" />`);
		$(elem).addClass('form-check-label');
		$inputElem.addClass('form-check-input');
	}
}
